import React from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import TestSnaking from "./TestSnaking";
//import { Button } from "@material-ui/core";

const Map = ({ startSnake, isData, positions, type, tme, verifyData, startAnimation }) => {

  const position = [46.227638, 2.213749];
  const zoom = 5;
  // const position = [51.505, -0.09];
  /*{const [startAnimation, setStartAnimation] = useState(false);
  const startSnake = () => setStartAnimation(!startAnimation);} */
  
  const ver = () => {
    if (verifyData && isData) {
      startSnake()
    }
    else return alert("vous n'avez pas data ou merci de vérifier si vous avez mis les dates");
  }
  return (
    <>
      <button onClick={ver} style={{ fontWeight: "bold", border: '1px solid black', color: 'green', marginBottom: '10px', marginLeft: '10px', marginTop: "2px" }}>Trace le!</button>
      <MapContainer center={position} zoom={zoom} style={{ height: "90vh", marginLeft: '10px' }}>
       <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        /> 
        {
          <TestSnaking isData={isData} positions={positions} tme={tme} type={type} startAnimation={startAnimation} />

        }
      </MapContainer>

    </>
  );
};

export default Map;
